var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dashBoardPage mt20"},[_c('div',{staticClass:"kqf-card mg10 pd10 mt20",staticStyle:{"font-size":"60px"}},[_vm._v(" 欢迎使用 ")])])
}]

export { render, staticRenderFns }